import { atom } from 'recoil';

export const enginesAtom = atom({
  key: 'enginesAtom', 
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});